module.exports = __webpack_public_path__ + "img/icon-select-blue.1b2865e6.svg";